import type { ReactNode } from 'react';
import { cn } from './cn.js';
import type { StatusTone } from './status-pill.js';

/// Situação escrita, para quando ela divide o lugar com texto comum.
///
/// A pílula tem borda, fundo e altura próprias: sozinha numa coluna ela se lê como etiqueta, mas
/// embaixo de um telefone ou ao lado de um nome parece um botão fora do alinhamento. Aqui o tom vai
/// num ponto e na cor da palavra, com o mesmo corpo do texto vizinho, e a linha continua sendo uma
/// linha. Os tons são os mesmos da pílula, vindos do CSS (`.hue-status-text-*`).
export function StatusText({
  tone,
  children,
  className,
}: {
  tone: StatusTone;
  children: ReactNode;
  className?: string | undefined;
}) {
  return (
    <span className={cn('hue-status-text', `hue-status-text-${tone}`, className)}>
      <span aria-hidden="true" className="hue-status-text-dot" />
      {children}
    </span>
  );
}
